import { render } from "./SharePopup.vue?vue&type=template&id=7c2ba87a&scoped=true"
import script from "./SharePopup.vue?vue&type=script&lang=js"
export * from "./SharePopup.vue?vue&type=script&lang=js"

import "@/Common/Styles/Share/socialMediaSharePopup.scss?vue&type=style&index=0&id=7c2ba87a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2ba87a"]])

export default __exports__